import React, { useCallback } from 'react';
import AsyncMultiSelect from './AsyncMultiSelect';
import { searchCities } from '../api';

export default function CitiesSelect({ value, onChange, countries = [], max = 50 }) {
  const countryIds = (countries || []).map((c) => c.id);
  const wrappedSearch = useCallback(
    (q, opts) => searchCities(q, countryIds, opts),
    [countryIds]
  );
  return (
    <AsyncMultiSelect
      label="Cities / States"
      placeholder={countries.length ? 'Search cities or states' : 'Select countries first'}
      value={value}
      onChange={onChange}
      searchFn={wrappedSearch}
      max={max}
    />
  );
}
